import * as React from 'react';
import { isBuildingSuggest } from '../../../../utils/types';
import { BuildingsSuggestionContent } from '../BuildingsSuggestionContent';
import { BaseSuggestionContent } from '../BaseSuggestionContent';
export var SuggestionInnerContent = function SuggestionInnerContent(props) {
  var item = props.item;

  if (isBuildingSuggest(item)) {
    return /*#__PURE__*/React.createElement(BuildingsSuggestionContent, props);
  } else {
    return /*#__PURE__*/React.createElement(BaseSuggestionContent, props);
  }
};